import React, { useRef } from "react";
import { motion, useScroll, useSpring } from "framer-motion";
import { JOURNEY, fadeUp } from "../../data";

export const Journey = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 65%", "end 60%"] });
  const height = useSpring(scrollYProgress, { stiffness: 80, damping: 20 });

  return (
    <section id="journey" className="relative py-24 md:py-32 overflow-hidden" style={{ background: "var(--midnight)" }}>
      <div className="absolute inset-0 opacity-40"
        style={{ background: "radial-gradient(700px circle at 80% 10%, rgba(25,118,210,0.14), transparent 45%)" }} />
      {/* slow editorial marquee */}
      <div className="marquee-track overflow-hidden border-y border-white/10 py-4 mb-20">
        <div className="marquee">
          {[...Array(2)].map((_, k) => (
            <span key={k} className="font-display font-bold text-white/[0.07] text-6xl md:text-8xl px-8 whitespace-nowrap">
              Listen · Understand · Serve · Build · Listen · Understand · Serve · Build ·
            </span>
          ))}
        </div>
      </div>

      <div className="container-x relative z-10">
        <motion.div variants={fadeUp} initial="hidden" whileInView="show" viewport={{ once: true }} className="mb-16">
          <span className="eyebrow" style={{ color: "var(--gold)" }}>The Journey So Far</span>
          <h2 className="font-display font-bold tracking-tight text-3xl md:text-4xl lg:text-5xl mt-4 text-ivory">
            Four chapters, one thread running through them all.
          </h2>
        </motion.div>

        <div ref={ref} className="relative pl-8 md:pl-0">
          {/* vertical track */}
          <div className="absolute left-[7px] md:left-1/2 top-0 bottom-0 w-px bg-white/10 md:-translate-x-1/2" />
          <motion.div style={{ scaleY: height, transformOrigin: "top" }}
            className="absolute left-[7px] md:left-1/2 top-0 bottom-0 w-px md:-translate-x-1/2"
            aria-hidden><div className="h-full w-full" style={{ background: "linear-gradient(var(--gold), var(--saffron))" }} /></motion.div>

          <div className="space-y-14 md:space-y-24">
            {JOURNEY.map((j, i) => (
              <motion.div key={j.no} variants={fadeUp} initial="hidden" whileInView="show" viewport={{ once: true, margin: "-80px" }}
                className={`relative grid md:grid-cols-2 gap-6 items-center ${i % 2 ? "md:[direction:rtl]" : ""}`}>
                <span className="absolute -left-[29px] md:left-1/2 top-1 md:-translate-x-1/2 h-4 w-4 rounded-full border-2"
                  style={{ background: "var(--gold)", borderColor: "var(--navy)" }} />
                <div className={`[direction:ltr] ${i % 2 ? "md:pl-16 md:text-left" : "md:pr-16 md:text-right"}`}>
                  <span className="font-display font-bold text-6xl" style={{ color: "rgba(246,195,68,0.28)" }}>{j.no}</span>
                </div>
                <div className="[direction:ltr] glass-dark rounded-2xl p-7 md:p-8">
                  <span className="eyebrow" style={{ color: "var(--gold)" }}>{j.tag}</span>
                  <h3 className="font-display font-semibold text-xl md:text-2xl text-ivory mt-3">{j.title}</h3>
                  <p className="font-body text-ivory/85 leading-relaxed mt-3 text-[15px]">{j.body}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
